import { endpoints } from "../config";
import { deleteData, getData, postData, putData } from "./api-utils";

const getVideoData = async () => {
  return await getData(endpoints.video);
};
const postVideoData = async (values) => {
  return await postData(endpoints.video, values);
};
const putVideoData = async (id, values) => {
  return await putData(endpoints.video + "/" + id, values);
};
const deletVideoData = async (id) => {
  return await deleteData(endpoints.video + "/" + id);
};

export { getVideoData, postVideoData, putVideoData, deletVideoData };
